import { makeAutoObservable } from 'mobx'

/** Tracks the imperative snackbars on screen, oldest first, so each can sit above the ones before it. */
export class SnackbarStack {
   openSnackbarIds: number[] = []

   private nextSnackbarId = 1

   constructor() {
      makeAutoObservable<SnackbarStack, 'nextSnackbarId'>(this, { nextSnackbarId: false }, { autoBind: true })
   }

   /**
    * Adds a snackbar to the top of the stack.
    * @returns The id to position and close it by.
    */
   open(): number {
      const snackbarId = this.nextSnackbarId++
      this.openSnackbarIds.push(snackbarId)
      return snackbarId
   }

   /**
    * Removes a snackbar, letting the ones above it move down.
    * @param snackbarId The id `open` returned.
    */
   close(snackbarId: number) {
      this.openSnackbarIds = this.openSnackbarIds.filter(openSnackbarId => openSnackbarId !== snackbarId)
   }

   /**
    * Where a snackbar sits in the stack.
    * @param snackbarId The id `open` returned.
    * @returns 0 for the bottom place, counting up.
    */
   positionOf(snackbarId: number): number {
      return Math.max(this.openSnackbarIds.indexOf(snackbarId), 0)
   }
}

export const snackbarStack = new SnackbarStack()
